import { render } from "./Individual.vue?vue&type=template&id=01db886c&ts=true"
import script from "./Individual.vue?vue&type=script&lang=ts"
export * from "./Individual.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__